import React from 'react';
import styled from 'styled-components';
import { Logo } from 'up-ops-web-shared-components/lib/components/uplift-icons';

import LanguageSelector from 'components/LanguageSelector';

const StyledHeader = styled.header`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
`;

const Navigation = () => {
  return (
    <StyledHeader>
      <Logo />
      <LanguageSelector />
    </StyledHeader>
  );
};

export default Navigation;
